import {createPortal} from "react-dom";
import {Transition} from "@headlessui/react";
import {CheckCircleIcon, XMarkIcon} from "@heroicons/react/24/outline/index";
import {XCircleIcon} from "lucide-react";

export interface Notification {
    title: string,
    description: string,
    type: 'success' | 'error',
    id?: string,
}

export function Notifications({notifications, onDismiss}: { notifications: Array<Notification>, onDismiss?: (id: string) => void }) {

    return createPortal(
        <>
            {/* Global notification live region, render this permanently at the end of the document */}
            <div
                aria-live="assertive"
                className="z-[100] pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6"
            >
                <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
                    {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
                    {notifications && notifications.map((notification) => {
                        const id = notification.id;
                        return (
                            <Transition show={!!notifications} key={id}>
                                <div
                                    className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition data-[closed]:data-[enter]:translate-y-2 data-[enter]:transform data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-100 data-[enter]:ease-out data-[leave]:ease-in data-[closed]:data-[enter]:sm:translate-x-2 data-[closed]:data-[enter]:sm:translate-y-0">
                                    <div className="p-4">
                                        <div className="flex items-start">
                                            <div className="flex-shrink-0">
                                                {notification.type === 'success' && <CheckCircleIcon aria-hidden="true"
                                                                                                     className="h-6 w-6 text-green-400"/>}
                                                {notification.type === 'error' &&
                                                    <XCircleIcon aria-hidden="true" className="h-6 w-6 text-red-400"/>}
                                            </div>
                                            <div className="ml-3 w-0 flex-1 pt-0.5">
                                                <p className="text-sm font-medium text-gray-900">{notification.title}</p>
                                                <p className="mt-1 text-sm text-gray-500">{notification.description}</p>
                                            </div>
                                            {onDismiss && id && (
                                                <div className="ml-4 flex flex-shrink-0">
                                                    <button
                                                        type="button"
                                                        className="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500"
                                                        onClick={() => onDismiss(id)}
                                                    >
                                                        <span className="sr-only">Close</span>
                                                        <XMarkIcon className="h-5 w-5" aria-hidden="true" />
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </Transition>
                        );
                    })}

                </div>
            </div>
        </>,
        document.body,
    )
}
